import { Button } from './Button';

interface Props {
  page: number;
  totalPages: number;
  totalCount: number;
  /** Plural noun for the footer ("cards", "packs"). */
  noun: string;
  onPageChange: (page: number) => void;
}

export function Pagination({ page, totalPages, totalCount, noun, onPageChange }: Props) {
  const last = Math.max(1, totalPages);
  return (
    <nav
      aria-label={`${noun} pagination`}
      className="flex items-center justify-between border-t border-[var(--co-border)] px-4 py-3"
    >
      <span className="text-[11px] text-[var(--co-muted)]">
        Page {page} of {last} • Total {totalCount} {noun}
      </span>
      <div className="flex gap-2">
        <Button
          variant="ghost"
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page <= 1}
          className="px-3 py-1 text-[12px]"
        >
          Prev
        </Button>
        <Button
          variant="ghost"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= last}
          className="px-3 py-1 text-[12px]"
        >
          Next
        </Button>
      </div>
    </nav>
  );
}
